import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SportsROFilters } from '../models'
import { initialState } from './initial-state'

import getSportsROCalculatorExtraReducer from '../thunks/get-sports-ro-calculator.thunk'

export const sportsROSlice = createSlice({
  name: 'sportsRO',
  initialState,
  reducers: {
    setIsloadingAction: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setSportROCalculatorFiltersAction(
      state,
      action: PayloadAction<SportsROFilters>,
    ) {
      state.filters = action.payload
    },
    resetSportsRO(state) {
      state.sportsRO = null
    },
  },
  extraReducers: (builder) => {
    getSportsROCalculatorExtraReducer(builder)
  },
})

export const SportsROActions = sportsROSlice.actions
